import { datadogLogs } from "@datadog/browser-logs";
import { TestVariantNames } from "src/features/homePageABCTest/common/enums";
import {
  SCREEN_NAME,
  getHomePageABCTestVideos,
  withLocalStorageCache,
} from "src/features/homePageABCTest/imports";

const DEFAULT_TEST_VIDEOS = [
  "https://resources.tango.me/home-page-abc-test/real-conn-desktop.mp4",
  "https://resources.tango.me/home-page-abc-test/real-conn-mobile.mp4",
  "https://resources.tango.me/web/main-landing-page-video-2.mp4",
  "https://resources.tango.me/web/main-landing-page-video-2.mp4",
  "https://resources.tango.me/home-page-abc-test/say-it-desktop.mp4",
  "https://resources.tango.me/home-page-abc-test/say-it-mobile.mp4",
];

const TEST_VARIANTS = (
  device: "desktop" | "mobile",
  homePageTestVideos: string[]
) => ({
  [TestVariantNames.NON_FLIRTY]: {
    videoUrl:
      device === "desktop" ? homePageTestVideos[0] : homePageTestVideos[1],
    header: {
      id: "home.real.connections",
      defaultMessage: "Real Connections. Real People. Real Time.",
    },
    subHeader: {
      id: "home.enjoy.cam.chats",
      defaultMessage:
        "Enjoy cam chats and fun interactions with amazing people from around the world.",
    },
    screenName: SCREEN_NAME.MAIN_HOME_PAGE_NON_FLIRTY,
  },
  [TestVariantNames.FLIRTY_WITH_STREAMERS]: {
    videoUrl:
      device === "desktop" ? homePageTestVideos[2] : homePageTestVideos[3],
    header: {
      id: "home.say.it.streamers",
      defaultMessage: "Say It. Stream It. Show It.",
    },
    subHeader: {
      id: "home.dive.into.vibe.streamers",
      defaultMessage:
        "Dive into the live vibe — enjoy playful cam-chats, instant video, and fun moments with one click.",
    },
    screenName: SCREEN_NAME.MAIN_HOME_PAGE_FLIRTY_STREAMER,
  },
  [TestVariantNames.FLIRTY]: {
    videoUrl:
      device === "desktop" ? homePageTestVideos[4] : homePageTestVideos[5],
    header: {
      id: "home.say.it.flirty",
      defaultMessage: "Say It. Stream It. Show It.",
    },
    subHeader: {
      id: "home.dive.into.vibe.flirty",
      defaultMessage:
        "Dive into the live vibe — enjoy playful cam-chats, instant video, and fun moments with one click.",
    },
    screenName: SCREEN_NAME.MAIN_HOME_PAGE_NON_FLIRTY_SENSUAL,
  },
  [TestVariantNames.DEFAULT]: null,
  [TestVariantNames.NONE]: null,
});

const HOME_PAGE_KEY = "web.home.page.abc.test.version";
const DEFAULT_VERSION_KEY = "hash1";

export const getHomePageABCTestObject = (
  newVersion: TestVariantNames,
  newVersionKey: string,
  device: "desktop" | "mobile"
) => {
  try {
    const homePageTestVideos = getHomePageABCTestVideos();
    const validHomePageTestVideos = homePageTestVideos.length
      ? homePageTestVideos
      : DEFAULT_TEST_VIDEOS;

    if (newVersion === TestVariantNames.NONE) {
      return TEST_VARIANTS(device, validHomePageTestVideos)[
        TestVariantNames.NONE
      ];
    }

    const result = withLocalStorageCache({
      localStorageKey: HOME_PAGE_KEY,
      value: newVersion,
      versionKey: newVersionKey,
      defaultVersionKey: DEFAULT_VERSION_KEY,
    }) as TestVariantNames;

    return TEST_VARIANTS(device, validHomePageTestVideos)[result];
  } catch (e) {
    const error = e as Error;
    datadogLogs.logger.warn(
      `${error?.message}, default page will be present`,
      { kind: "homePageABCTest" },
      error
    );

    const homePageTestVideos = getHomePageABCTestVideos();
    const validHomePageTestVideos = homePageTestVideos.length
      ? homePageTestVideos
      : DEFAULT_TEST_VIDEOS;

    return TEST_VARIANTS(device, validHomePageTestVideos)[newVersion];
  }
};
